export enum CookieConsentNL {
    All = 'compleet',
    Extensive = 'uitgebreid',
    Basic = 'basis'
}
